/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

export const CREATE_PARTICIPANT_ANSWERS_V3 = gql`
  mutation CreateParticipantAnswersV3(
    $input: CreateParticipantAnswersV3Input!
    $caseId: String!
    $app: ApplicationInput!
  ) {
    createParticipantAnswersV3(input: $input, caseId: $caseId, app: $app)
  }
`;
